import Rellax from 'rellax';

// @ts-ignore
// eslint-disable-next-line
new Rellax('.j-rellax', {
    center     : true,
    breakpoints: [670, 768, 1280]
});
// interface Promo {
//     block: HTMLElement;
//     image: HTMLElement;
//     imageWidth: number;
//     imageHeight: number;
// }
//
// const promoBlocks = [...document.querySelectorAll('.j-promo')] as HTMLElement[];
// const blocks = [] as Promo[];
//
// promoBlocks.forEach((block: HTMLElement) => {
//     const image = block.querySelector('.j-promo-image') as HTMLElement;
//
//     if (image) {
//         const realImg = new Image();
//
//         realImg.onload = () => {
//             blocks.push({
//                 block,
//                 image,
//                 imageWidth : realImg.naturalWidth,
//                 imageHeight: realImg.naturalHeight
//             });
//         };
//
//         // @ts-ignore
//         realImg.src = image.src;
//     }
// });
//
// const updateScrollInfo = (): void => {
//     blocks.forEach((promo: Promo) => {
//         const rect = promo.block.getBoundingClientRect();
//         const viewportHeight = window.innerHeight;
//         const blockTop = rect.top;
//         const blockBottom = rect.bottom;
//         // const blockHeight = rect.height;
//
//         // const offset = 450 - (blockHeight / promo.imageHeight);
//         const offset = 200;
//         let scrollPercentage = 0;
//
//         if (blockTop < viewportHeight && blockBottom > 0) {
//             if (blockTop >= 0 && blockBottom <= viewportHeight) {
//                 scrollPercentage = 50;
//             } else if (blockTop < 0) {
//                 scrollPercentage = 50 + ((blockTop / viewportHeight) * offset);
//             } else if (blockBottom > viewportHeight) {
//                 scrollPercentage = 50 - (((viewportHeight - blockBottom) / viewportHeight) * offset);
//             }
//         }
//
//         if (rect.top < viewportHeight && rect.bottom > 0) {
//             promo.image.style.objectPosition = `center ${scrollPercentage.toFixed(2)}%`;
//         }
//     });
// };
//
// window.addEventListener('scroll', updateScrollInfo);
// window.addEventListener('resize', updateScrollInfo);
//
// // Initial call to set the scroll percentage on load
// updateScrollInfo();
